import React from 'react';
import { APPLE_THEME, TYPOGRAPHY } from '../theme';

const ACCENTS = {
  green: '#34C759',
  purple: '#AF52DE',
  blue: '#007AFF',
  orange: '#FF9F0A'
};

const Icon = ({ name, size = 22, color = APPLE_THEME.metalicGray }) => {
  const common = {
    fill: 'none',
    stroke: color,
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
      {name === 'warranty' && (
        <g {...common}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </g>
      )}
      {name === 'fast' && (
        <g {...common}>
          <path d="M13 3l-2 9h8l-10 9 2-9H3l10-9z" />
        </g>
      )}
      {name === 'original' && (
        <g {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M8 12l2 2 4-4" />
        </g>
      )}
      {name === 'price' && (
        <g {...common}>
          <path d="M12 1v22M8 5h4a4 4 0 0 1 0 8H8m0 0h6" />
        </g>
      )}
      {name === 'pickup' && (
        <g {...common}>
          <rect x="3" y="7" width="18" height="13" rx="2" />
          <path d="M16 7V5a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v2" />
        </g>
      )}
      {name === 'support' && (
        <g {...common}>
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.09 4.2 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.06.67.2 1.34.41 1.98a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.64.21 1.31.35 1.98.41A2 2 0 0 1 22 16.92z" />
        </g>
      )}
    </svg>
  );
};

const InfoCard = ({ icon, title, desc, descAccent, href, accent = 'blue' }) => (
  <a
    className="infocard"
    href={href}
    style={{
      display: 'block',
      textDecoration: 'none',
      background: APPLE_THEME.white,
      border: `1px solid ${APPLE_THEME.lightMetalicGray}`,
      borderRadius: '20px',
      padding: '24px',
      transition: 'box-shadow 200ms ease, transform 200ms ease'
    }}
    onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 10px 28px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
  >
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 12,
          background: APPLE_THEME.lightMetalicGray,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
      >
        <Icon name={icon} color={ACCENTS[accent] || ACCENTS.blue} />
      </div>
      <div>
        <div style={{ color: APPLE_THEME.black, fontFamily: TYPOGRAPHY.hero, fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
          {title}
        </div>
        <div style={{ color: APPLE_THEME.metalicGray, fontFamily: TYPOGRAPHY.body, fontSize: 14, lineHeight: 1.5 }}>
          {desc}
          {descAccent && (
            <>
              <br />
              <span style={{ color: ACCENTS[accent] || ACCENTS.blue }}>{descAccent}</span>
            </>
          )}
        </div>
      </div>
    </div>
  </a>
);

const InfoCards = () => {
  const items = [
    { icon: 'price', title: 'Harika ödeme seçenekleri.', desc: 'Kredi kartı, havale ve taksit imkânı.', href: '/iletisim', accent: 'green' },
    { icon: 'original', title: 'Sizin kadar özenli.', desc: 'Cihazınıza uygun çözümler.', descAccent: 'Yüksek kalite parça ve işçilik.', href: '/destek#support-faq', accent: 'purple' },
    { icon: 'fast', title: 'Ücretsiz teslim seçenekleri.', desc: 'Aynı gün hızlı teslim.', descAccent: 'Mağazadan alım imkânı.', href: '/hizmetler', accent: 'green' },
    { icon: 'support', title: 'Kişisel destek.', desc: 'Uzmanla direkt iletişim.', descAccent: 'Telefon ve WhatsApp ile.', href: '/iletisim', accent: 'blue' }
  ];

  return (
    <section aria-label="Neden C-Store" style={{ background: APPLE_THEME.backgroundGray, padding: '36px 0 32px 0' }}>
      <div style={{ maxWidth: 980, margin: '0 auto', padding: '0 20px' }}>
        <div style={{ marginBottom: 12 }}>
          <h2
            style={{
              color: APPLE_THEME.black,
              fontFamily: TYPOGRAPHY.hero,
              fontSize: 'clamp(22px, 3.6vw, 30px)',
              fontWeight: 700,
              letterSpacing: '-0.01em',
              lineHeight: 1.2
            }}
          >
            Neden C‑Store?
            <span style={{ color: APPLE_THEME.metalicGray, fontFamily: TYPOGRAPHY.body, fontWeight: 500 }}> Bizden hizmet almak için şimdi daha da fazla sebebiniz var.</span>
          </h2>
        </div>

        <div className="infocards-wrap" style={{ position: 'relative' }}>
          <div className="infocards" style={{ display: 'grid', gap: 16, gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))' }}>
            {items.map((it, i) => (
              <InfoCard
                key={i}
                icon={it.icon}
                title={it.title}
                desc={it.desc}
                descAccent={it.descAccent}
                href={it.href}
                accent={it.accent}
              />
            ))}
          </div>
          <div className="infocards-fade" aria-hidden style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: 28, pointerEvents: 'none', background: `linear-gradient(to left, ${APPLE_THEME.backgroundGray}, transparent)` }} />
          <div className="infocards-chev" aria-hidden style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', display: 'none' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={APPLE_THEME.metalicGray} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoCards;
